<template>
    <div class="col-md-12">
        <div>
            <div class="row">
                <div class="col-md-12 mb-3">
                    <div @click="toggleModalVehicle"
                         class="btn btn-success float-right d-flex align-items-center"
                         title="Create booking">
                        <span class="material-icons-outlined cursor-pointer mr-1">post_add</span>
                        <span>Create Vehicle</span>
                    </div>
                </div>
            </div>
            <form @submit.prevent="deleteVehicles">
                <div class="position-relative pagination-control">
                    <data-table
                        :url="url"
                        :filters="filters"
                        :columns="columnsVehicles"
                        :per-page="perPage"
                        :classes="classes"
                        :order-by="orderBy"
                        :order-dir="orderDir"
                        :meta="columns.meta"
                    >
                        <div slot="filters" slot-scope="{ tableFilters, perPage, vehicles }">
<!--                            <div class="row my-3 d-flex justify-content-end align-items-left">
                                <div class="col-md-3">
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                            <span class="material-icons-outlined cursor-pointer">search</span>
                                        </button>
                                        <input name="name" v-model="filters.search"
                                               class="form-control form-control border-0 py-0 pl-0 shadow-none form-input"
                                               placeholder="Search vehicles"/>
                                    </div>
                                </div>
                                <div class="col-md-9">
                                </div>
                            </div>-->
                            <br/>
                        </div>
                        <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                        <tr>
                            <th>
                                <!--                                    <input type="checkbox" v-model="allSelected" @change="selectAll($event)"/>-->
                            </th>
                            <th :style="column.label==='Vehicle'? 'width:90%' : 'width:10%'" @click="sort(column.id)"
                                v-if="column.label!==''"
                                v-for="column in columnsVehicles">
                                <span> {{ column.label }} </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody slot="body" slot-scope="{ data }">
                        <tr
                            :key="vehicle.id"
                            v-for="(vehicle,key) in data">
                            <td
                                :key="column.name"
                                v-for="column in columns"
                            >
                                <data-table-cell
                                    :value="vehicle"
                                    :name="column.name"
                                    :meta="column.meta"
                                    :comp="column.component"
                                    :classes="column.classes">
                                </data-table-cell>

                                <slot v-if="column.label === ''">
                                    <input type="checkbox"
                                           v-model="vehicles[vehicle.id]"
                                    >
                                </slot>

                                <slot v-if="column.label === 'Edit'">
                                    <a :href="`/vehicles/${vehicle.id}/edit`" title="Edit Vehicle">
                                        <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                    </a>
                                </slot>
                            </td>
                        </tr>
                        </tbody>
                    </data-table>
                </div>
                <br/>
                <div class="d-flex justify-content-between">
                    <div>
                        <div
                            @click="deleteVehicles()"
                            class="btn  btn-sm btn-primary d-flex align-items-center float-left button-delete-driver"
                            title="Delete booking">
                                      <span class="material-icons-outlined cursor-pointer mr-1"
                                            title="delete">delete</span>
                            <span class="">Delete vehicles</span>
                        </div>
                    </div>
                    <div>
<!--                        <label class="pr-2">Vehicles per page:</label>
                        <div class="d-inline-flex center bg-white border rounded-lg div-focus border-2">
                            <select class="form-control bg-white border-0 py-0 shadow-none"
                                    v-model="filters.length"
                                    style="width: 150px;">
                                <option
                                    :key="index"
                                    :value="records"
                                    v-for="(records, index) in perPage">
                                    {{ records }}
                                </option>
                            </select>
                        </div>-->
                    </div>
                </div>
            </form>
        </div>
        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalIntervalVehicle}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add new vehicle</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalVehicle"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addNewVehicle">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <input type="text"
                                           required
                                           autocomplete="none"
                                           class="form-control  border-0 py-0 shadow-none form-input"
                                           placeholder="Name"
                                           v-model="newVehicle.name"
                                    >
                                </div>
                            </div>

                            <button class="btn btn-primary">
                                Save
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalIntervalVehicle" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
export default {
    name: "VehicleDataTable",
    data() {
        return {
            url: '/vehicles-list',
            vehicles: [],
            currentVehicles: [],
            orderBy: 'id',
            orderDir: 'desc',
            search: '',
            searchVehicles: '',
            perPage: [100, 10, 25, 50],
            filters: {
                search: '',
                length: 100,
                column: 'id',
                dir: 'desc',
                type: '',
            },
            loading: false,
            columns: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Driver',
                    name: 'name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Type',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'OptimoRoute Id',
                    name: 'company',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Phone',
                    name: 'phone',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Edit',
                    id: 'edit',
                    orderable: false,
                },
            ],
            columnsVehicles: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Vehicle',
                    name: 'name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: '',
                    id: 'edit',
                    orderable: false,
                },
            ],
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            selected: [],
            allSelected: false,
            activeModalInterval: false,
            activeModalIntervalVehicle: false,
            show: false,
            isSubmit: false,
            newDriver: {'type': 1},
            newVehicle: {},
            warehouses: {},
            fileName: '',
            attachment: '',
        }
    },
    methods: {
        fetchData() {
            //
        },
        toggleModalVehicle() {
            const body = document.querySelector("body");
            this.activeModalIntervalVehicle = !this.activeModalIntervalVehicle;
            this.activeModalIntervalVehicle
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        addNewVehicle: function () {
            axios.post(`/vehicles`, this.newVehicle).then((response) => {
                window.location.href = `/drivers-and-companies`;
            }).catch(err => {
                alert('failed to create new vehicle')
            })
        },
        deleteVehicles() {
            axios.post(`/delete-multiple-vehicles`, this.vehicles).then((response) => {
                window.location.href = `/drivers-and-companies`;
            }).catch(err => console.log(err))
        },
        async selectAll(event) {
            if (event.target.checked) {
                if (this.allSelected) {
                    Object.entries(this.currentVehicles).forEach(entry => {
                        const [key, value] = entry;
                        this.vehicles[key] = true;
                    });
                }
            } else {
                this.vehicles = {};
            }
        }
    },
    created() {
        return this.fetchData()
    },
}
</script>

<style>
.custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
}

.custom-file-input::before {
    content: 'Choose file';
    display: inline-block;
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
}

.custom-file-input:hover::before {
    border-color: black;
}

.custom-file-input:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}

.import-driver {
    margin-left: 20px;
    margin-right: 20px;
}

.button-delete-driver {
    background-color: red !important;
    border-color: red !important;
}

select option:disabled {
    color: #999;
}
</style>
